import { getSwcEnv } from './get-swc-env';
export const getSwcConfig = ({ isTs, isJsx, pkg }, { format }) => {
    return {
        env: getSwcEnv(pkg),
        jsc: {
            target: undefined,
            parser: isTs
                ? {
                    syntax: 'typescript',
                    tsx: isJsx,
                }
                : { syntax: 'ecmascript', jsx: isJsx },
        },
        module: {
            type: formatToTypeMap[format ?? 'es'],
        },
        sourceMaps: true,
        swcrc: false,
    };
};
const formatToTypeMap = {
    amd: 'amd',
    umd: 'umd',
    iife: 'umd',
    system: 'systemjs',
    systemjs: 'systemjs',
    cjs: 'commonjs',
    commonjs: 'commonjs',
    es: 'es6',
    esm: 'es6',
    module: 'es6',
};
